import Vue from "vue"
import VueRouter from "vue-router"
import Currencies from "../views/currencies.vue";
import DeliveryInformations from "../views/deliveryInformations.vue";
import ImportConfig from "../views/importConfig.vue";
import ExportConfig from "../views/exportConfig.vue";
import ComponentImport from "../views/componentImport.vue";
import ComponentEdit from "../views/componentEdit.vue";
import PPanelImport from "../views/ppanelImport.vue";
import PPanel from "../views/ppanel.vue";
import FullPpanelExport from "../views/fullppanelexport.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/currencies",
    name: "Currencies",
    component: Currencies
  },
  {
    path: "/deliveryInformations",
    name: "Delivery Informations",
    component: DeliveryInformations
  },
  {
    path: "/importConfig",
    name: "Import Configuration",
    component: ImportConfig
  },
  {
    path: "/exportConfig",
    name: "Export Configuration",
    component: ExportConfig
  },
  {
    path: "/componentImport",
    name: "Component Import",
    component: ComponentImport
  },
  {
    path: "/ppanelImport",
    name: "PPanel Import",
    component: PPanelImport
  },
  {
    path: "/ppanel",
    name: "PPanel View",
    component: PPanel
  },
  {
    path: "/fullppanelexport",
    name: "Full PPanel Export",
    component: FullPpanelExport
  },
  {
    path: "/componentEdit",
    name:"Edit Components",
    component: ComponentEdit
  }
];

const router = new VueRouter({
  routes
});

export default router
